import React, { useState } from "react";
import contactimage from "../assets/otherimages/contactus.svg";
import { Helmet } from "react-helmet";
const ContactUs = () => {
  const whatsappNumber = "971554421108";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, message } = formData;

    const text = `Hello Blue Diamond Rent a Car,
    I would like to get in touch with you. Here are my details:
    Name: ${name}
    Email: ${email}
    Phone: ${phone}
    Message: ${message}`;

    const url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      text
    )}`;

    window.open(url, "_blank");
  };

  return (
    <>
    <Helmet>
        <title>Contact Us | Blue Diamond Rent Car Dubai</title>
        <meta
          name="description"
          content="Get in touch with Blue Diamond Rent Car for bookings, inquiries, and car rental assistance in Dubai."
        />
        <link rel="canonical" href="https://bluediamondrentcar.com/contact" />
      </Helmet>
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-[#0B2F6B] leading-tight">
            CONTACT US
          </h2>
          <p className="text-[#123775] mt-3 text-[18px] md:text-[20px] font-medium">
            Get in touch with Blue Diamond Rent a Car
          </p>
        </div>

        {/* Desktop/Laptop (≥1024px) → 2 columns */}
        <div className="hidden lg:grid grid-cols-2 gap-16 items-center">
          {/* Left - Contact Image */}
          <div className="flex justify-center">
            <img
              src={contactimage}
              alt="Contact Illustration"
              className="w-full max-w-lg"
              loading="lazy"
            />
          </div>

          {/* Right - Form */}
          <Form
            handleSubmit={handleSubmit}
            formData={formData}
            handleChange={handleChange}
          />
        </div>

        {/* Tablet (768px–1023px) → form only */}
        <div className="hidden md:block lg:hidden">
          <Form
            handleSubmit={handleSubmit}
            formData={formData}
            handleChange={handleChange}
          />
        </div>

        {/* Mobile (<768px) → image top + form below */}
        <div className="block md:hidden space-y-12">
          <div className="flex justify-center">
            <img
              src={contactimage}
              alt="Contact Illustration"
              className="w-full max-w-xs sm:max-w-sm"
              loading="lazy"
            />
          </div>
          <Form
            handleSubmit={handleSubmit}
            formData={formData}
            handleChange={handleChange}
          />
        </div>
      </div>
    </section>
    </>
    
  );
};

/* Reusable Form Component (unchanged styling for fields & button) */
const Form = ({ handleSubmit, formData, handleChange }) => (
  <form
    onSubmit={handleSubmit}
    className="
      bg-[#123775] 
      p-8 sm:p-10 md:p-14 
      rounded-[40px] sm:rounded-[60px] md:rounded-[80px] 
      shadow-lg 
      w-full max-w-md md:max-w-[450px] 
      mx-auto md:ml-auto
    "
  >
    <h2 className="text-white font-semibold text-[18px] text-center mb-4">
      Get in Touch!
    </h2>

    {/* Name */}
    <div className="mb-4">
      <input
        type="text"
        name="name"
        placeholder="Your Name"
        value={formData.name}
        onChange={handleChange}
        className="bg-white text-[#111111] font-normal w-full shadow-md placeholder:font-semibold text-[13px] rounded-lg p-3 placeholder:text-[#6C8FBE] focus:outline-none focus:ring-0"
        required
      />
    </div>

    {/* Email */}
    <div className="mb-4">
      <input
        type="email"
        name="email"
        placeholder="Your Email"
        value={formData.email}
        onChange={handleChange}
        className="bg-white text-[#111111] font-normal w-full shadow-md placeholder:font-semibold text-[13px] rounded-lg p-3 placeholder:text-[#6C8FBE] focus:outline-none focus:ring-0"
        required
      />
    </div>

    {/* Phone */}
    <div className="mb-4">
      <input
        type="tel"
        name="phone"
        placeholder="Your Phone"
        value={formData.phone}
        onChange={handleChange}
        className="bg-white text-[#111111] font-normal w-full shadow-md placeholder:font-semibold text-[13px] rounded-lg p-3 placeholder:text-[#6C8FBE] focus:outline-none focus:ring-0"
        required
      />
    </div>

    {/* Message */}
    <div className="mb-6">
      <textarea
        name="message"
        rows="5"
        placeholder="Your Message"
        value={formData.message}
        onChange={handleChange}
        className="bg-white text-[#111111] font-normal w-full shadow-md placeholder:font-semibold text-[13px] rounded-lg p-3 placeholder:text-[#6C8FBE] focus:outline-none focus:ring-0"
        required
      ></textarea>
    </div>

    {/* Submit Button */}
    <div className="flex justify-center">
      <button
        type="submit"
        className="bg-white text-[#123775] font-semibold text-[16px] py-3 px-4 rounded-lg shadow-lg hover:bg-gray-100 transition"
      >
        Send Message
      </button>
    </div>
  </form>
);

export default ContactUs;
